import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { SentryRoutes } from '@app/analytics';

import { Profile } from './Profile/Profile';
import { ContactDetails } from './Profile/ContactDetails';
import { Dashboard } from './Dashboard';
import { StudyPreferences } from './Profile/StudyPreferences';
import { OwnedDevices } from './Profile/OwnedDevices';
import { Home } from './Home/Home';
import { ParticipationSummary } from './ParticipationSummary';
import { StudyApplication } from './StudyApplication/StudyApplication';
import { Studies } from './Studies/Studies';
import { ProfessionalProfile } from './Profile/ProfessionalProfile';
import { useNotificationListener } from '@app/api';
import { LoginParticipant } from './Auth/LoginParticipant';
import { SignupParticipant } from './Auth/SignupParticipant';
import { Preferences } from './Auth/Preferences';
import { Settings } from './Profile/Settings';
import { VerifyEmailSignUp } from './Auth/VerifyEmailSignUp';
import { Notifications } from './notifications/Notifications';
import { LoginAction } from './Auth/LoginAction';
import { Onboarding } from './Onboarding/Onboarding';
import { OnboardingSteps } from './Onboarding/OnboardingSteps';
import { PersonalProfile } from './Profile/PersonalProfile';
import { StudyProposals } from './Onboarding/StudyProposals';
import { TechCheck } from './TechCheck/TechCheck';
import { AppliedResult } from './StudyApplication/AppliedResult';
import { TandemzPresentation } from './StudyApplication/TandemzPresentation';
import { StudyReturnLandings } from './StudyReturnLandings/StudyReturnLandings';
import { NoSignupUnmoderatedApplication } from './StudyApplication/NoSignupUnmoderatedApplication';
import { useTranslation } from 'react-i18next';

export const AppRouter = () => {
  useNotificationListener();
  const { t } = useTranslation();
  return (
    <SentryRoutes>
      <Route path="/*" element={<Dashboard />}>
        <Route path="" element={<Home />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="profile/*" element={<Profile />}>
          <Route path="contact-details" element={<ContactDetails />} />
          <Route path="personal-profile" element={<PersonalProfile />} />
          <Route
            path="professional-profile"
            element={
              <ProfessionalProfile
                icon="ri-briefcase-3-line"
                title={t('participantSpace.profile.professionalProfile')}
              />
            }
          />
          <Route path="owned-devices" element={<OwnedDevices />} />
          <Route path="study-preferences" element={<StudyPreferences />} />
          <Route path="settings/*" element={<Settings />} />
        </Route>
        <Route path="studies/*" element={<Studies />} />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Route>
      <Route path="/onboarding/*">
        <Route path="" element={<Onboarding />} />
        <Route path="steps/:step" element={<OnboardingSteps />} />
        <Route path="studies" element={<StudyProposals />} />
      </Route>
      <Route path="/p/:id/*" element={<ParticipationSummary />} />
      <Route path="/s/:id/*" element={<StudyApplication />} />
      <Route path="/s-ext/:id/*" element={<NoSignupUnmoderatedApplication />} />
      <Route path="/spm/:id/*" element={<TandemzPresentation />} />
      <Route
        path="/spm-quant/:id/*"
        element={<TandemzPresentation unmoderated />}
      />
      <Route path="/a/:id/applied" element={<AppliedResult />} />
      <Route path="/login" element={<LoginParticipant />} />
      <Route path="/study-landing/*" element={<StudyReturnLandings />} />
      <Route path="/login-action/*" element={<LoginAction />} />
      <Route path="/registration" element={<SignupParticipant />} />
      <Route path="/registration/preferences" element={<Preferences />} />
      <Route path="/tech-check/:id/*" element={<TechCheck />} />
      <Route
        path="/registration/verify-email"
        element={<VerifyEmailSignUp />}
      />
    </SentryRoutes>
  );
};
